import { render, staticRenderFns } from "./FileManagementPreOffice.vue?vue&type=template&id=c77a9ff2&"
import script from "./FileManagementPreOffice.vue?vue&type=script&lang=js&"
export * from "./FileManagementPreOffice.vue?vue&type=script&lang=js&"
import style0 from "./FileManagementPreOffice.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1477836768/src/github.com/FebosIO/Febos-AMI/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c77a9ff2')) {
      api.createRecord('c77a9ff2', component.options)
    } else {
      api.reload('c77a9ff2', component.options)
    }
    module.hot.accept("./FileManagementPreOffice.vue?vue&type=template&id=c77a9ff2&", function () {
      api.rerender('c77a9ff2', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/febos/chile/approvals/components/trays/FileManagementPreOffice.vue"
export default component.exports